var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"container px-2 py-0",attrs:{"wrap":""}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }